var OCS = OCS || {};
OCS.User = OCS.User || {};
OCS.Classes = OCS.Classes || {};

OCS.Classes.User = new Class({
    Implements: [Options, Events],
    options: {
        update_user_preference_string: 'user_preference_updated',
        user_preferences: {
            
        }
    },
    initialize: function (op) {
        this.setOptions(this.parse_options(op));
    },
    parse_options: function (op) {
        if (op.user_preferences !== undefined && op.user_preferences && op.user_preferences.constructor === Array) {
            op.user_preferences = {}; // If its an array, then they had no preferences set.
        }
        return op;
    },
    get_user_preferences: function () {
        return this.options.user_preferences;
    },
    get_user_preference: function (key) {
        if (this.options.user_preferences[key] !== undefined) {
            return this.options.user_preferences[key];
        } else {
            return false;
        }
    },
    update_user_preference: function (key, value) {
        if (this.get_user_preference(key) !== value) {
            var old_value = this.get_user_preference(key);
            this.options.user_preferences[key] = value;
            this.fireEvent(this.options.update_user_preference_string, {'key': key, 'new_value': value, 'old_value': old_value});
        }
    }
});
